import React from "react";
import querystring from "querystring-es3";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { workareaURLStyle, workareaAPIStyle } from "util/workarea";
import workareaViewStateToProps from "../selectors";
import * as actions from "../actions";
import WorkareaLayout from "./WorkareaLayout";

class WorkareaView extends React.Component {
  static propTypes = {
    workarea: PropTypes.string,
    organization: PropTypes.string,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired,
    actions: PropTypes.shape({
      setWorkarea: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    workarea: "",
    organization: ""
  };

  componentDidMount() {
    const search = this.props.location.search.replace("?", "");
    const query = querystring.parse(search);
    if (
      query.workarea &&
      workareaAPIStyle(query.workarea) !== this.props.workarea
    ) {
      this.props.actions.setWorkarea(workareaAPIStyle(query.workarea));
    }
  }

  updateQueryAndRedirect(workarea) {
    const {
      location: { pathname },
      history: { push }
    } = this.props;

    const search = this.props.location.search.replace("?", "");
    const query = querystring.parse(search);

    const defaultNext =
      pathname === "/portal2/workarea" ? "/portal2/ctd" : pathname;
    const {
      next = defaultNext,
      organization = this.props.organization
    } = query;
    if (organization) {
      push(`${next}?workarea=${workarea}&organization=${organization}`);
    } else {
      push(`${next}?workarea=${workarea}`);
    }
  }

  handleSelectWorkarea(nextWorkarea) {
    if (this.props.workarea !== nextWorkarea) {
      this.props.actions.setWorkarea(nextWorkarea);
    }
    this.updateQueryAndRedirect(workareaURLStyle(nextWorkarea));
  }

  render() {
    return (
      <WorkareaLayout
        {...this.props}
        onSelectWorkarea={workarea => this.handleSelectWorkarea(workarea)}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(workareaViewStateToProps, mapDispatchToProps)(WorkareaView)
);
